import { Outlet } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import Sidebar from "../components/sidebar";
import TopHeader from "../components/topheader";

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <>
      <div>
        <TopHeader />
        <Sidebar isSidebarOpen={isSidebarOpen} />
        <div className="p-4 sm:ml-64 bg-gray-100 h-screen overflow-y-auto">
          <div className="py-4 mt-8 dashboard-content">
            <Outlet />{" "}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
